export const namespaced = true;
import axios from 'axios';

export const state = {
    doctorOptions: [],
}

export const mutations = {
    SET_DOCTOR_OPTIONS(state, payload) {
        let doctors = payload.filter(doctor => {// Filter out when hidden true and universal false.
            return !(doctor.hidden && !doctor.universal); // return false to filter out. 
        }).map(doctor => {
            return {
                text: doctor.name,
                value: doctor.id,
                email: doctor.emailAddress,
                url: 'https://reports.dvgapp.org/question/388-reservation-code-status?doctor_id=' + doctor.id
            };
        });
        state.doctorOptions = doctors;
    },
}

export const actions = {
    async fetchDoctorOptions({ rootState, dispatch, commit }) {
        return await axios
            .get(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/hoh/doctorlist?filter=all`)
            .then(res => {
                if (res.status == 200) {
                    commit('SET_DOCTOR_OPTIONS', res.data);
                    return res.data;
                }
            })
            .catch(error => {
                console.log(error);
                dispatch('showError', 'Error loading doctor options', { root: true });
            });
    },

    async submitDoctorCodes({ rootState, dispatch }, payload) {
        return await axios
            .post(`${rootState.baseUrlApi}/labhoh-restful-api/reservationcode/email`, payload)
            .then(res => {
                if (res.status == 204 || res.status == 200) return true;
            })
            .catch(error => {
                console.log(error);
                dispatch('showError', 'Error submitting doctor codes data');
                return false;
            });
    },
}

export const getters = {
    getDoctorOptions: state => {
        return state.doctorOptions;
    }
}